import { apiV1PostUsers, QueryV1PostUsersParams } from '@/modules/api';

class UserService {
  async createOrUpdate(params: QueryV1PostUsersParams) {
    return apiV1PostUsers(params);
  }
}

export const userService = new UserService();
